"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgHeroCar = function SvgHeroCar(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M812.8 953.6c0 38.4-134.4 70.4-300.8 70.4s-300.8-32-300.8-73.6C211.2 912 345.6 880 512 880s300.8 32 300.8 73.6zM995.2 240v48c0 9.6-6.4 16-16 16l-51.2 3.2c-9.6 0-16 6.4-16 16l-16 371.2c0 6.4-9.6 16-19.2 16H774.4c-9.6 0-22.4-9.6-22.4-19.2V592c0-9.6-6.4-16-16-16-73.6 6.4-150.4 9.6-224 9.6-76.8 0-150.4-3.2-224-9.6-9.6 0-16 6.4-16 16v99.2c0 9.6-12.8 19.2-22.4 19.2H147.2c-12.8 0-19.2-6.4-19.2-16l-16-371.2c0-9.6-6.4-16-16-16L44.8 304c-9.6 0-16-6.4-16-16v-48c0-9.6 6.4-16 16-16h89.6c6.4 0 16-6.4 16-16 6.4-32 35.2-86.4 48-115.2 16-25.6 48-92.8 144-92.8h339.2c96 0 128 67.2 140.8 92.8 12.8 28.8 41.6 83.2 48 115.2 3.2 9.6 9.6 16 19.2 16h89.6c9.6 0 16 6.4 16 16zM368 374.4c0-35.2-12.8-60.8-86.4-60.8-64 0-67.2 28.8-67.2 60.8s25.6 51.2 67.2 51.2c44.8 0 86.4-19.2 86.4-51.2zm144-147.2c144 0 259.2 6.4 259.2 6.4s-16-54.4-32-86.4C710.4 92.8 668.8 96 640 96H390.4c-32 0-73.6 0-99.2 51.2-19.2 32-32 86.4-32 86.4s108.8-6.4 252.8-6.4zm297.6 147.2c0-35.2-3.2-60.8-67.2-60.8-73.6 0-86.4 28.8-86.4 60.8s38.4 51.2 86.4 51.2c44.8 0 67.2-19.2 67.2-51.2z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgHeroCar, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;